import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { SelectField } from '@unite-us/ui';
import { useFindNetworksByName, useFindNetworksById } from 'src/components/Backoffice/api/hooks/v1/networkHooks';

const NetworkTypeaheadField = ({ curretNetworksIds }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const { data: networks, isLoading, refetch } = useFindNetworksByName(searchTerm);
  const { data: preloadedNetworks } = useFindNetworksById(curretNetworksIds?.toString());

  const loadOptions = (query) => {
    setSearchTerm(query);
    refetch();
    return networks;
  };

  return (
    <Field
      name="networks"
      validate={(selectedItems) => {
        if (!isLoading && !selectedItems?.length) {
          return 'Required';
        }
        return undefined;
      }}
    >
      {({ input, meta }) => {
        const mergedOptions = [...networks];

        if (input.value) {
          input.value.forEach((selected) => {
            if (!mergedOptions.some((option) => option.id === selected.id)) {
              mergedOptions.push(selected);
            }
          });
        }

        if (preloadedNetworks && curretNetworksIds.length) {
          preloadedNetworks.forEach((preloaded) => {
            if (!mergedOptions.some((option) => option.id === preloaded.id)) {
              mergedOptions.push(preloaded);
            }
          });
        }

        return (
          <SelectField
            loadOptions={loadOptions}
            options={mergedOptions}
            placeholder="Select network ids..."
            id="networks-field"
            loadingText="Searching..."
            label="Networks"
            multiple
            valueKey="id"
            labelKey="name"
            searchThreshold={0}
            position="top"
            required
            className={`md:col-span-6 xl:col-span-6 px-0 ${meta.error && meta.touched ?
              'ui-select-field--has-error has-error ui-form-field--has-error has-error' :
              ''
              }`}
            dataTestElement="network_ids_select"
            error={meta.error && meta.touched ? meta.error : ''}
            {...input}
          />
        );
      }}
    </Field>
  );
};

NetworkTypeaheadField.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  curretNetworksIds: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
};

export default NetworkTypeaheadField;
